const emoji = [
  { text: 'smile', native: '🙂' },
  { text: 'smiley', native: '😃' },
  { text: 'grinning', native: '😄' },
  { text: 'blush', native: '😊' },
  // { text: 'relaxed', native: '☺️' },
  { text: 'wink', native: '😉' },
  { text: 'heart_eyes', native: '😍' },
  { text: 'kissing_heart', native: '😘' },
  { text: 'kissing_closed_eyes', native: '😘' },
  { text: 'kissing', native: '😗' },
  { text: 'kissing_smiling_eyes', native: '😗' },
  { text: 'stuck_out_tongue_winking_eye', native: '😜' },
  { text: 'stuck_out_tongue_closed_eyes', native: '😝' },
  { text: 'stuck_out_tongue', native: '😝' },
  { text: 'flushed', native: '😮' },
  { text: 'pensive', native: '😬' },
  { text: 'relieved', native: '😌' },
  { text: 'unamused', native: '😒' },
  { text: 'disappointed', native: '😒' },
  { text: 'persevere', native: '😦' },
  { text: 'cry', native: '😪' },
  { text: 'joy', native: '😢' },
  { text: 'sob', native: '😭' },
  { text: 'sleepy', native: '😪' },
  { text: 'disappointed_relieved', native: '😥' },
  { text: 'cold_sweat', native: '😰' },
  { text: 'sweat_smile', native: '😅' },
  { text: 'sweat', native: '😓' },
  { text: 'weary', native: '😩' },
  { text: 'tired_face', native: '😫' },
  { text: 'fearful', native: '😨' },
  { text: 'scream', native: '😱' },
  { text: 'angry', native: '😠' },
  { text: 'rage', native: '😡' },
  { text: 'dog', native: '🐶' },
  { text: 'sunglasses', native: '😎' },
  { text: 'no_mouth', native: '🤐' },
  { text: 'sleeping', native: '😴' },
  { text: 'laughing', native: '😁' },
  { text: 'smirk', native: '😲' },
  { text: 'worried', native: '🙁' },
  { text: 'triumph', native: '😣' },
  { text: 'confounded', native: '🤢' },
  { text: 'grin', native: '🤭' },
  { text: 'rollingeyes', native: '🙄' },
  { text: 'open_mouth', native: '🤬' },
  { text: 'question', native: '🧐' },
  { text: 'mask', native: '🤫' },
  { text: 'confused', native: '😵‍💫' },
  { text: 'trollface', native: '💀' },
  { text: 'collision', native: '🤕' },
  { text: 'wave', native: '👋' },
  { text: 'clap', native: '👏' },
  { text: 'grimacing', native: '🤩' },
  { text: 'worried', native: '🥺' },
  { text: 'anguished', native: '🥺' },
  { text: 'grimacing', native: '😏' },
  { text: 'kiss', native: '💋' },
  { text: 'heart', native: '❤' },
  { text: 'broken_heart', native: '💔' },
  { text: 'fist', native: '🫂' },
  { text: 'thumbsup', native: '👍' },
  { text: 'thumbsdown', native: '👎' },
  { text: 'v', native: '✌' },
  { text: 'ok_hand', native: '👌' },
  { text: 'beer', native: '🍺' },
  { text: 'coffee', native: '☕' },
  { text: 'birthday', native: '🎂' },
  { text: 'rose', native: '🌹' },
  { text: 'hocho', native: '🔪' },
  { text: 'fade', native: '🥀' },
  { text: 'boom', native: '💣' },
  { text: 'shit', native: '💩' },
  { text: 'crescent_moon', native: '🌙' },
  { text: 'sun_with_face', native: '🌞' },
  { text: 'gift', native: '🎁' },
  { text: 'pig', native: '🐷' },
  { text: 'dancer', native: '[企鹅跳跳]' },
  { text: 'Hurt', native: '😭' },
  { text: 'Broken', native: '[裂开]' },
  { text: 'Sigh', native: '[叹气]' },
  { text: 'LetMeSee', native: '[让我看看]' },
  { text: 'Awesome', native: '[666]' },
  { text: 'Boring', native: '[翻白眼]' },
  { text: 'Wow', native: '[哇]' },
  { text: 'MyBad', native: '[打脸]' },
  { text: 'NoProb', native: '[好的]' },
  { text: 'Doge', native: '[旺柴]' },
  { text: 'Respect', native: '[社会社会]' },
  { text: 'Emm', native: '[Emm]' },
  { text: 'OMG', native: '[天啊]' },
  { text: 'Sweats', native: '[汗]' },
  { text: 'GoForIt', native: '[加油]' },
  { text: 'Onlooker', native: '[吃瓜]' },
  { text: 'Yeah!', native: '[耶]' },
  { text: 'Concerned', native: '[皱眉]' },
  { text: 'Smart', native: '[机智]' },
  { text: 'Facepalm', native: '[奸笑]' },
  { text: 'Smirk', native: '[捂脸]' },
  { text: 'Hey', native: '[嘿哈]' },
  { text: 'Duh', native: '😒' },
  { text: 'LetDown', native: '😔' },
  { text: 'Terror', native: '😱' },
  { text: 'Lol', native: '😂' },
  { text: 'Flushed', native: '[脸红]' },
  { text: 'Sick', native: '😷' },
  { text: 'Happy', native: '[笑脸]' },
  { text: 'relaxed', native: '[害羞]' },
  { text: 'Worship', native: '🙏' },
  { text: 'Party', native: '🎉' },
  { text: 'Packet', native: '🧧' },
  { text: 'Rich', native: '🀅' },
  { text: 'Blessing', native: '[福]' },
  { text: 'Fireworks', native: '🎇' },
  { text: '爆竹', native: '🧨' },
  { text: 'dig', native: '[抠鼻]' }
];

export default emoji;
